export default __webpack_public_path__ + "static/media/purple-divider-bottom.1926286b.svg";